export function naturalSort(items, getItem = item => item) {
    const options = {
        numeric: true,
        ignorePunctuation: true,
        sensitivity: 'base',
    };
    items.sort((a, b) => getItem(a).localeCompare(getItem(b), 'co', options));
    return items;
}

export function smartSort(a, b) {
    if (typeof a === 'string' && typeof b === 'string') {
        return a.localeCompare(b, 'co', {
            numeric: true,
            ignorePunctuation: true,
            sensitivity: 'base',
        });
    }
    if (a > b) {
        return -1;
    }
    if (a < b) {
        return 1;
    }
    return 0;
}
